(function() {
  'use strict';

  angular
    .module('sempraWebapp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $httpProvider, $mdDateLocaleProvider, moment) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Enable CORS
    $httpProvider.defaults.useXDomain = true;
    delete $httpProvider.defaults.headers.common['X-Requested-With'];

    $httpProvider.interceptors.push('httpInterceptor');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;

    $mdDateLocaleProvider.formatDate = function(date) {
      // moment.locale('en');
      // var dateFormat = moment().localeData().longDateFormat('L');
      return moment(date).format('DD/MM/YYYY');
    };

    $mdDateLocaleProvider.parseDate = function(dateString) {
      if (!dateString) return null;
      var parts = dateString.split('/');
      if (parts.length !== 3) return null;
      return new Date(parts[2], parts[1] - 1, parts[0]);
    };

    $mdDateLocaleProvider.firstDayOfWeek = 1;

    $mdDateLocaleProvider.msgCalendar = 'Calendar view';
    $mdDateLocaleProvider.msgOpenCalendar = 'Open calendar';

  }

})();
